import { useEffect } from "react";

const DEFAULT_TITLE = "Sofia & Jason";
const PAGE_TITLE = "Registry | Sofia & Jason";

/** Used when REACT_APP_REGISTRY_FUND_URL is missing (e.g. Vercel env not set yet). CRA inlines env at build time. */
const DEFAULT_REGISTRY_FUND_URL =
  "https://withjoy.com/jason-and-sofia-jun-26/registry";

const IMG_BALANCED_ROCK = `${process.env.PUBLIC_URL || ""}/images/Balanced_Rock_sunset.jpg`;

function registryFundHref() {
  const raw = (process.env.REACT_APP_REGISTRY_FUND_URL || "").trim();
  const base = raw || DEFAULT_REGISTRY_FUND_URL;
  if (/^https?:\/\//i.test(base)) return base;
  return `https://${base}`;
}

const buttonBase =
  "inline-block px-10 py-4 font-sans text-xs font-bold uppercase tracking-[0.15em] transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-container";

const buttonEnabled =
  "bg-primary-container text-on-primary hover:bg-primary active:scale-[0.98]";

export default function RegistryPage() {
  const fundUrl = registryFundHref();

  useEffect(() => {
    document.title = PAGE_TITLE;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, []);

  return (
    <main className="min-h-[60vh] bg-surface pb-24 pt-28 selection:bg-tertiary-fixed-dim selection:text-on-tertiary-fixed md:pt-32">
      <section className="px-6 py-16 md:px-20 md:py-24">
        <div className="mx-auto max-w-5xl">
          <h1 className="mb-8 font-headline text-5xl text-primary-container md:mb-10 md:text-7xl">
            Registry &amp; Funds
          </h1>

          <div className="flex flex-col items-stretch gap-14 md:flex-row md:items-start md:justify-between md:gap-10 lg:gap-16">
            <div className="min-w-0 max-w-xl flex-1">
              <p className="mb-10 font-body text-lg leading-relaxed text-on-surface opacity-70">
                Your presence is truly our present, but if you wish to honor us
                with a gift, a contribution to our future together would be
                cherished.
              </p>
              <a
                href={fundUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={`${buttonBase} ${buttonEnabled}`}
              >
                Gift to our future fund
              </a>
            </div>

            <div className="flex shrink-0 justify-center overflow-visible py-8 md:justify-end md:py-4 md:pl-4 lg:py-8">
              <figure className="m-0 w-fit rotate-45 shadow-[0_14px_36px_-6px_rgba(52,48,34,0.4)]">
                <div className="box-border w-44 bg-[#FAFAF8] p-2 pb-7 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.04)] sm:w-52 sm:p-2.5 sm:pb-8 md:w-48 md:pb-7 lg:w-52 lg:pb-8">
                  <div className="aspect-[4/3] w-full overflow-hidden bg-neutral-200">
                    <img
                      src={IMG_BALANCED_ROCK}
                      alt="Balanced Rock at sunset, warm light on red sandstone with desert brush and distant blue mountains"
                      className="h-full w-full object-cover object-center"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                </div>
              </figure>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
